import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.117 3.883a.884.884 0 011.767 0v5.233h5.232a.884.884 0 010 1.768h-5.232v5.232a.884.884 0 01-1.767 0v-5.232H3.884a.884.884 0 010-1.768h5.233V3.883z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
